import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from '@reduxjs/toolkit';

const initialState = {
  editMode: false,
  addNew: false,
  localeID: -1,
  surveyID: -1,
  surveys: [],
  translations: [],
  translationForm: [],
  currentformPage:[],
}

const getsurveyLocales = (surveys, id) => {
  const survey = surveys.find(
    (item) => item.id === id
  );
  if (!survey) return []
  return survey.locales
};

const translationsSlice = createSlice({
  name: "translation",
  initialState,
  reducers: {
    setEditMode: {
      reducer(state, action) {
        state.editMode = action.payload;
      },
    },
    setAddNew: {
      reducer(state, action) {
        state.addNew = action.payload;
      },
    },
    setLocaleID: {
      reducer(state, action) {
        state.localeID = action.payload;
      },
    },
    setSurveys: {
      reducer(state, action) {
        state.surveys = action.payload;
      },
    },
    setSurveyID: {
      reducer(state, action) {
        state.surveyID = action.payload;
        if (action.payload === -1) {
          state.surveyLocales = [];
        } else {
          const survey = state.surveys.find(
            (item) => item.id === action.payload
          );
          state.surveyLocales = survey ? survey.locales : [];
        }
      },
    },
    initTranslationForm: {
      reducer(state, action) {
          state.translationForm = action.payload.map((item) => ({
          formFieldId: nanoid(),
          ...item,
        }));
        state.translations = action.payload
      },
    },
    resetTranslationForm: {
      reducer(state, action) {
        state.translationForm = state.translations.map((item) => ({
          formFieldId: nanoid(),
          ...item,
        }));
      },
    },
    clearTranslationForm: {
      reducer(state, action) {
        state.translationForm = []
        state.translations = []
        state.currentformPage = []
      },
    },
    updateTranslationForm: {
      reducer(state, action) {
        state.translationForm = action.payload;
      },
    },
    setcurrentformPage: {
      reducer(state, action) {
        state.currentformPage = action.payload;
      },
    },

  },
  
});

export const {
  setEditMode,
  setAddNew,
  setLocaleID,
  setSurveys,
  setSurveyID,
  setSurveyLocales,
  updateSurveyLocales,
  updateTranslationForm,
  setcurrentformPage,
  initTranslationForm,
  resetTranslationForm,
  clearTranslationForm
} = translationsSlice.actions;

export const SelectEditMode = (state) => state.translation.editMode;
export const SelectAddNew = (state) => state.translation.addNew;
export const SelectLocaleID = (state) => state.translation.localeID;
export const SelectSurveyID = (state) => state.translation.surveyID;
export const SelectTranslations = (state) => state.translation.translations
export const SelectTranslationForm = (state) => state.translation.translationForm
export const SelectCurrentFormPage = (state) => state.translation.currentformPage
export const SelectSurveyLocales = (state) => {
  return getsurveyLocales(
    state.translation.surveys, 
    state.translation.surveyID)
}

export const SelectAllSurveys = (state) => state.translation.surveys;


export default translationsSlice.reducer;
